$(function () {
  if (!customElements.get('count-down')) {
    customElements.define(
      'count-down',
      class countDown extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.countdownInterval = setInterval(() => this.updateCountdown(), 1000);
          this.updateCountdown();
        }
        updateCountdown() {
          const $time = $(this).find('.time');
          if (!$time.length) return;
          let time = $time.data('time');
          // 先统一转换格式
          time = time.trim().replace(/\//g, '-');
          const timeFormat = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;

          if (!timeFormat.test(time)) {
            $(this).css('display', 'none');
            return;
          }

          const endTime = new Date(time).getTime();
          const now = new Date().getTime();
          const timeDifference = endTime - now;
          if (timeDifference > 0) {
            if ($(this).css('display') !== 'block') {
              $(this).css('display', 'block');
            }
          } else {
            $(this).css('display', 'none');
            clearInterval(this.countdownInterval);
            return;
          }
          const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
          const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

          $time.find('.days').text(days.toString().padStart(2, '0'));
          $time.find('.hrs').text(hours.toString().padStart(2, '0'));
          $time.find('.min').text(minutes.toString().padStart(2, '0'));
          $time.find('.sec').text(seconds.toString().padStart(2, '0'));
        }
        disconnectedCallback() {
          clearInterval(this.countdownInterval);
        }
      }
    );
  }
});
